<template>
    <div class="settings-message-default">

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Mensagem Padrão</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Submenu -->
                <mu-submenu :submenu="submenu"></mu-submenu>
            </mu-col>
        </mu-row>

        <!-- Listagem de mensagem padrão -->
        <div class="default-message" v-if="!defaultmessage.loading">
            <mu-paper :z-depth="1">

                <!-- Listagem dos mensagem padrão tablet/desktop -->
                <mu-data-table :columns="defaultmessage.columns" :data="defaultmessage.list" @row-click="edit" v-if="viewport !== 'mobile'" class="mu-table-custom">
                    <template slot="empty">
                        <div class="box-table-empty">
                            Não foi encontrado registros de mensagens padrão
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <td>{{ scope.row.description }}</td>
                        <td>{{ scope.row.code }}</td>
                    </template>
                </mu-data-table>

                <!-- Listagem de mensagem padrão mobile -->
                <mu-list textline="two-line" v-if="viewport === 'mobile'">
                    <span v-for="(item, key) in defaultmessage.list" :key="key">
                        <mu-list-item button :to="{ name: 'app.settings.messagedefault.edit', params: { id: item.id } }">
                            <mu-list-item-content>
                                <mu-list-item-title>{{ item.description }}</mu-list-item-title>
                                <mu-list-item-sub-title>Código {{ item.code }}</mu-list-item-sub-title>
                            </mu-list-item-content>
                            <mu-list-item-action>
                                <font-awesome-icon icon="pen" class="icon-md icon-margin-left"/>
                            </mu-list-item-action>
                        </mu-list-item>
                        <mu-divider></mu-divider>
                    </span>
                </mu-list>
            </mu-paper>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="defaultmessage.paging.total > defaultmessage.paging.size">
                <mu-pagination :total="defaultmessage.paging.total" :page-count="5" :page-size="defaultmessage.paging.size" :current.sync="defaultmessage.paging.page" @change="load()"></mu-pagination>
            </mu-flex>
        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de mensagens padrão" v-if="defaultmessage.loading"></mu-loading>

    </div>
</template>

<script>
    import MessageDefaultService from '@/services/settings/message-default'

    export default {
        name: 'app-settings-message-default',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Configurações',
                        route: 'app.settings',
                        disabled: false
                    },
                    {
                        text: 'Mensagem Padrão',
                        disabled: true
                    }
                ],
                submenu: [
                    {
                        name: 'Criar Mensagem Padrão',
                        icon: 'plus',
                        route: 'app.settings.messagedefault.create',
                        color: 'primary',
                        textColor: null
                    }
                ],
                defaultmessage: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0
                    },
                    columns: [
                        { title: 'Título', name: 'title' },
                        { title: 'Código', name: 'code', width: 150 }
                    ],
                    list: []
                }
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Método responsável por chamar o load() logo após o componente ser criado
         */
        created () {
            this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Método que redireciona para edição do item, esse método é chamado em cada linha da listagem
             */
            edit (index, row, event) {
                this.$router.push({ name: 'app.settings.messagedefault.edit', params: { id: row.id } }).catch(err => { if (err) console.log(err.name || '') })
            },

            /**
             * Método responsável por carregar a listagem de palavras chaves
             */
            async load () {
                try {
                    this.defaultmessage.loading = true

                    let result = await MessageDefaultService.findAll({
                        page: this.defaultmessage.paging.page
                    })

                    if (result && result.status) {
                        this.defaultmessage.paging.page = result.currentPage
                        this.defaultmessage.paging.total = result.rowCount
                        this.defaultmessage.list = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.defaultmessage.loading = false
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Utilizado para verificar se o acesso é de desktop, table ou mobile
             */
            viewport () {
                return this.$currentViewport.label
            }
        }
    }
</script>

<style lang="stylus" scoped>

    .default-message
        margin 20px 0

        .mu-list
            padding 0

        td
            cursor pointer

        .row
            margin 0 20px
            padding 15px 0

            .text-right
                text-align right

        .paginate
            padding 20px

        .mu-paper
            padding 0px

    .mu-button-float-right
        float right

</style>
